<template>
  <section class="register">
    <i v-if="loading" class="fas fa-spinner loading-big"></i>
    <div v-else class="box">
      <div class="header">
         <transition name="title">
          <div v-if="page === 0" key="update" class="title" style="text-transform: capitalize">{{ name }}</div>
          <div v-if="page === 1" key="info" class="title">Festival</div>
          <div v-if="page === 2" key="events" class="title">{{ name }}</div>
        </transition>
        <div @click="$router.push('/festival')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="box-content">
        <transition name="page">
          <!-- Ações -->
          <div v-if="page === 0" key="page-0">
            <form @submit.prevent class="form">
              <button type="button" @click="page = 1" class="button-form"><i class="fas fa-info-circle"></i><span>Informações</span></button>
            </form>
          </div>
          <!-- Informações -->
          <div v-if="page === 1" key="page-1">
            <form @submit.prevent class="form">
              <div class="show-image-container">
                <img src="img/festival_image_125.svg" width="20" height="140" style="margin-right: 5px" />
                <form @submit.prevent @click="$refs.fileUpload.click()" class="show-image">
                  <i v-if="!image" class="fas fa-camera"></i>
                  <img v-if="image" :src="imageFile ? image : `${API_IMG}/festival/${business.id}/${festivalId}/${image}`">
                  <input ref="fileUpload" type="file" accept="image/jpeg" @change="changeImage($event.target.files[0])">
                </form>
                <img src="img/festival_image_950.svg" width="100%" height="20" style="margin-top: 10px" />
                <div v-if="error.indexOf('image') > -1" class="hint" style="font-size:0.8em;color:#880000;margin-top:3px;margin: 0 auto;">você esqueceu a imagem do festival</div>
              </div>
              <!-- Nome -->
              <label>Nome</label>
              <input v-model="name" type="text" placeholder="Nome Festival" :class="{ error : error.indexOf('name') > -1 }" style="text-transform: capitalize" />
              <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu de digitar o nome</div>

              <!-- Url Festival-->
              <!-- <label>Url</label>
              <div>
                <span>https://tiketera.com.br/festival/</span><input v-model="url" type="text" placeholder="Url Festival" :class="{ error : error.indexOf('url') > -1 }" />
              </div> -->
              <div v-if="error.indexOf('url') > -1" class="hint">você esqueceu de digitar a url do festival</div>
              <!-- Descrição -->
              <label>Descrição</label>
              <quill-editor v-model="description" :options="editorOption"></quill-editor>
              <div v-if="error.indexOf('description') > -1" class="hint">você esqueceu de digitar a descrição do festival</div>
              <!-- Default -->
              <!-- Date de Termino -->
              <label>Data de Término</label>
              <input v-model="dateEnd" type="date" placeholder="Data de Término" :class="{ error : error.indexOf('dateEnd') > -1 }" />
              <div v-if="error.indexOf('dateEnd') > -1" class="hint">você esqueceu de digitar a data de término</div>
            </form>
            <div class="actions">
              <button @click="page = 0" class="button-previous" :style="id === 'new' ? 'visibility: hidden' : 'visibility: visible'"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
              <button @click="nextStep()" class="button-next"><span>Continuar</span><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-angle-right'"></i></button>
            </div>
          </div>
          <!-- Remover -->
          <div v-if="page === 2" key="page-2">
            <form @submit.prevent class="form">
              <label>Selecione os Shows para este festival</label>
              <Autocomplete :selectList="true" :model="addShow" :list="shows.map(x => x.name).filter(x => !selectedShows.find(y => y.name === x))" placeholder="Selecionar Evento" :class="{ error : error.includes('showDates') }" />
                <div v-for="show in selectedShows" :key="show.id" @click="removeShow(show.id)" class="list-form hover">
                <div class="form-data">{{ show.name }}</div>
              </div>
              <div v-if="error.indexOf('events') > -1" class="hint">você esqueceu de selecionar ao menos um evento</div>
            </form>
            <div class="actions">
              <button @click="page = 1" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
              <button @click="createUpdate" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>

import logger from '../../logger'
import { mapState } from 'vuex'
import { get, create, update, remove } from '../api/festival'
import { getCurrentShows } from '../api/show'
import { Quill, quillEditor } from 'vue-quill-editor'
import Autocomplete from './Autocomplete'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['12px', '14px', '16px', '20px']
Quill.register(sizeStyle, true)

export default {
  name: 'festival',
  components: { quillEditor, Autocomplete },
  props: ['id'],
  data () {
    return {
      API_IMG: process.env.VUE_APP_IMG,
      url: null,
      festivalId: null,
      page: 0,
      loading: false,
      error: [],
      name: null,
      dateEnd: null,
      description: null,
      show: '',
      shows: [],
      selectedShows: [],
      image: null,
      imageFile: null,
      editorOption: {
        placeholder: 'Descrição do festival',
        modules: {
          toolbar: [
            [{ 'size': ['12px', false, '16px', '20px'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'align': [] }, { 'list': 'bullet' }, { 'list': 'ordered' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image', 'video'],
            ['clean']
          ]
        }
      }
    }
  },
  computed: {
    ...mapState(['business'])
  },
  async mounted () {
    this.loading = true
    // Update
    if (this.id !== 'new') {
      try {
        const festival = await get(this.id)
        this.festivalId = festival.id
        this.name = festival.name
        this.url = festival.url
        this.description = festival.description
        this.dateEnd = festival.dateEnd ? this.formatISODate(festival.dateEnd) : null
        this.image = festival.images ? festival.images[0] : null
        this.selectedShows = festival.shows.map(x => {
          x.show = x.id
          return x
        })
      } catch (error) {
        logger.error(error, this)
      }
    } else {
      this.page = 1
    }
    this.loading = false
  },
  watch: {
    name (value) {
      if (value) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const url = value.toString().toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(new RegExp(a.split('').join('|'), 'g'), c => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, '-e-') // Replace & with 'and'
          // eslint-disable-next-line no-useless-escape
          .replace(/[^\w\-]+/g, '') // Remove all non-word characters
          .replace(/--+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, '') // Trim - from end of text
        this.url = url
      }
    }
  },
  methods: {
    addShow (show) {
      if (show && show.length > 0 && this.shows.find(x => x.name === show)) this.selectedShows.push(this.shows.find(x => x.name === show))
    },
    removeShow (show) {
      const pos = this.selectedShows.map(x => x.id).indexOf(show)
      this.selectedShows.splice(pos, 1)
    },
    async nextStep () {
      this.loading = true
      this.error = []
      if (this.page === 1) {
        if (!this.name || this.name.length === 0) this.error.push('name')
        if (!this.description || this.description.length === 0) this.error.push('description')
        if (!this.image) this.error.push('image')
        if (this.error.length === 0) {
          this.shows = await getCurrentShows()
          this.page = 2
        }
      }
      this.loading = false
    },
    changeImage (file) {
      const maxWidth = 1000
      const maxHeight = 400
      const reader = new FileReader()
      reader.onload = e => {
        const img = new Image()
        const self = this
        img.onload = function () {
          let width = this.width
          let height = this.height
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width
              width = maxWidth
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height
              height = maxHeight
            }
          }
          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(img, 0, 0, width, height)
          const dataUrl = canvas.toDataURL('image/jpeg', 1)
          self.image = dataUrl
          const binStr = atob(dataUrl.split(',')[1])
          const arr = new Uint8Array(binStr.length).map((x, i) => binStr.charCodeAt(i))
          self.imageFile = new Blob([arr], { type: 'image/jpeg' })
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    async createUpdate () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        if (this.id === 'new') {
          // Create festival
          await create(
            this.name,
            this.description,
            this.dateEnd ? this.formatISODate(this.dateEnd) : null,
            this.selectedShows.map(x => x.id),
            this.imageFile,
            this.url
          )
        } else {
          // Update festival
          await update(
            this.id,
            this.name,
            this.description,
            this.dateEnd ? this.formatISODate(this.dateEnd) : null,
            this.imageFile,
            this.selectedShows.map(x => x.id),
            this.url
          )
        }
        this.loading = false
        this.$router.push('/festival')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    },
    async remove () {
      this.loading = true
      try {
        await remove(this.id)
        this.$router.push('/festival')
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../_asset/scss/_variables";
  .register .box {
    height: 100vh;
    margin: 0;
    border: none;
    border-radius: 0px !important;
    max-height: none;
    .header {
      border-radius: 0px !important;
    }
  }
  @media screen and (min-width: $desktop-width) {
    .register {
      .box {
        max-width: 450px;
        height: initial;
        max-height: calc(100% - 10vh);
        margin: 0;
        border: none;
        border-radius: 6px !important;
        .header {
          border-radius: 10px 10px 0 0 !important;
        }
      }
    }
  }
  .show-image-container {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
  height: 160px;
  margin-bottom: 10px;

  input {
    display: none;
  }

  .show-image {
    flex-grow: 1;
    width: min-content;
    &:hover {
      i {
        border: 3px solid #999;
      }
      img {
        filter: grayscale(50%);
      }
    }

    i {
      color: #999;
      font-size: 50px;
      height: 100%;
      max-width: 338px;
      max-height: 138px;
      margin: 0 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 3px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
    }

    img {
      width: 100%;
      height: 100%;
      max-width: 338px;
      max-height: 138px;
      margin: 0 5px;
      object-fit: cover;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.ql-picker-item[data-value='12px']::before, .ql-picker-label[data-value='12px']::before {
  content: 'Pequeno' !important;
  font-size: 12px;
}
.ql-picker-item[data-value='16px']::before, .ql-picker-label[data-value='16px']::before {
  content: "Medio" !important;
  font-size: 16px;
}
.ql-picker-item[data-value='20px']::before, .ql-picker-label[data-value='20px']::before {
  content: 'Grande' !important;
  font-size: 20px;
}
</style>
